<template>
	<SimpleModalComponent
		heading="Notify client of submission"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<p class="create-submission-notification-modal__text">
				Are you sure? This will send out a Boundary Live notification and email to every client user added to this project.
			</p>

			<p
				v-if="error_message"
				class="error-message"
			>
				{{ error_message }}
			</p>
		</template>

		<template #buttons>
			<button
				class="button"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				:class="{ 'button--loading': loading }"
				@click="confirm"
			>
				Confirm
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { ref, defineEmits, defineProps } from 'vue';
import { useDataStore } from '../../stores/data';

const emit = defineEmits( [ 'notification-created', 'close-modal' ] );

const props = defineProps( {
	submission: {
		required: true,
		type: Object
	}
} );

const { createSubmissionNotification } = useDataStore();

const loading = ref( false );
const error_message = ref( null );

const confirm = async() => {
	error_message.value = null;
	loading.value = true;

	try {
		const response = await createSubmissionNotification( parseInt( props.submission.id ) );
		if ( response && response.data ) {
			emit( 'notification-created' );
		}
	} catch ( error ) {
		error_message.value = error;
		loading.value = false;
	}
};
</script>